<template>
	<section>
		<h2 class="onboarding-title">How did you hear about us?</h2>
		<p class="onboarding-text lead">
			One last thing—tell us where you found Grub Vision.
		</p>

		<div class="form-group">
			<label class="form-label" for="onboarding-referral-source">
				Referral source <span class="required-mark" aria-hidden="true">*</span>
			</label>
			<select
				id="onboarding-referral-source"
				class="form-select"
				v-model="sourceModel"
				required
				aria-required="true">
				<option disabled value="">Select an option</option>
				<option
					v-for="option in REFERRAL_SOURCES"
					:key="option.value"
					:value="option.value">
					{{ option.label }}
				</option>
			</select>
		</div>

		<div v-if="sourceModel === 'other'" class="form-group">
			<label class="form-label" for="onboarding-referral-other">
				Where did you hear about us?
				<span class="required-mark" aria-hidden="true">*</span>
			</label>
			<input
				id="onboarding-referral-other"
				type="text"
				class="form-control"
				v-model="otherModel"
				placeholder="Tell us where you found us"
				maxlength="160"
				required
				aria-required="true" />
		</div>

		<p class="onboarding-hint">
			<i class="bi bi-megaphone"></i>
			Your answer helps us understand which communities are finding Grub
			Vision.
		</p>
	</section>
</template>

<script setup>
	import { computed } from "vue"
	import { REFERRAL_SOURCES } from "../../../../shared/referralSources.js"

	const props = defineProps({
		modelValue: {
			type: String,
			default: "",
		},
		other: {
			type: String,
			default: "",
		},
	})

	const emit = defineEmits(["update:modelValue", "update:other"])

	const sourceModel = computed({
		get: () => props.modelValue ?? "",
		set: (value) => {
			emit("update:modelValue", value)
			if (value !== "other") emit("update:other", "")
		},
	})

	const otherModel = computed({
		get: () => props.other ?? "",
		set: (value) => emit("update:other", value),
	})
</script>

<style scoped>
	.required-mark {
		color: #dc2626;
	}

	.onboarding-hint {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		margin-top: 0.75rem;
		padding: 0.5rem 0.75rem;
		background: rgba(56, 189, 248, 0.15);
		color: #0369a1;
		border-radius: 12px;
		font-weight: 600;
	}

	.onboarding-hint i {
		font-size: 1.1rem;
	}
</style>
